<script setup lang="ts">
import { useEntityClient } from '@/data/useEntityClient'
import { injectHubRowContext } from '@/modules/Workspaces/KnowledgeHub/Hubs/FileTable/context'
import { getHubFileFields } from '@/modules/Workspaces/KnowledgeHub/Hubs/getHubFileFields'
import IconButton from '@/uiKit/IconButton.vue'
import Menu from '@/uiKit/Menu'
import { computed, toRef } from 'vue'
import { useHubEntityStatus } from './useHubEntityStatus'

defineEmits<{ menuOpen: [boolean] }>()

const { item } = injectHubRowContext()
const { mutate: deleteEntity } = useEntityClient().deleteMutation()
const rowContext = injectHubRowContext()

const hubFields = computed(() => {
  return getHubFileFields({
    properties: item.value.fileProject.properties,
    entity: item.value.entity,
  })
})

const { status, recompute, hasFieldErrors } = useHubEntityStatus(
  hubFields,
  toRef(item.value.fileProject.id),
)

const hasError = computed(() => status.value === 'error')

const showDivider = computed(() => {
  return hasFieldErrors.value || !hasError.value
})

function onDelete() {
  const { fileProject, entity } = rowContext.item.value
  deleteEntity({
    entityIds: [entity.id],
    projectId: fileProject.id,
    workspaceId: fileProject.workspaceId,
  })
}

function onOpen() {
  const fileURL = item.value.fields.file.manualValue
  if (fileURL) {
    window.open(fileURL, '_blank')
  }
}

function onRetry() {
  recompute()
}
</script>

<template>
  <Menu.Root
    v-slot="{ getTriggerProps }"
    :positioning="{ placement: 'bottom-end', offset: { mainAxis: 4 } }"
    close-on-select
    @change:open="$emit('menuOpen', $event)"
  >
    <IconButton
      v-bind="getTriggerProps()"
      icon="more-dots"
      size="sm"
      variant="transparent"
      :aria-label="`Edit ${item.fileName}`"
      @click.stop
    />

    <Menu.Content class="min-w-40">
      <Menu.Item
        v-if="hasFieldErrors"
        icon="refresh"
        label="Retry file"
        @click.stop.prevent="onRetry"
      />
      <Menu.Item
        v-if="!hasError"
        icon="expand"
        label="Open"
        @click.stop.prevent="onOpen"
      />

      <Menu.Divider v-if="showDivider" />

      <Menu.Item
        critical
        icon="trash"
        label="Delete"
        @click.stop="onDelete"
      />
    </Menu.Content>
  </Menu.Root>
</template>
